<template>
  <div class="w-full h-full pt-5">
    <div class="flex">
      <h1 class="text-xl text-left font-extrabold pl-4">Organisation</h1>
      <div class="w-7/12 mt-1 ml-4">
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </div>
    <div>
      <div class="mx-3 mt-6">
        <Card class="mt-6 p-5">
          <div class="flex mb-6" style="justify-content: flex-end">
            <Button class="text-white" :background="appearance.buttonColor || defaultBTNColor" @click="handleClick">
              New Designation
            </Button>
          </div>
          <template v-if="!showError" v-slot:footer>
            <card-footer printcard reloadcard @print="print" @reload="reload()" @sortType="handleSort($event)"
              @option="handleOptionSelect($event)" @searchResult="handleSearch($event)" />
          </template>
        </Card>
      </div>
      <div v-if="!showError" class="p-3">
        <sTable :headers="designationHeader" :items="designationArray" style="width: 100%" aria-label="designationTable"
          :pagination-list="metaData" id="printMe" @page="handlePage($event)" @itemsPerPage="handleItemsPerPage($event)"
          :loading="loadingData" class="w-full" has-number>
          <template v-slot:item="{ item }">
            <span v-if="item.level">{{
              item.data.level ? item.data.level.name : "------"
            }}</span>
            <span v-else-if="item.reportsTo">{{
              item.data.reportsTo ? item.data.reportsTo.name : "------"
            }}</span>
            <span v-else-if="item.isSupervisory">{{
              item.data.isSupervisory ? "Supervisory" : "Non-Supervisory"
            }}</span>
            <span v-else-if="item.orgDesignationLocations">
              <span class="flex gap-2" v-if="item.data.orgDesignationLocations.length > 0">
                <p class="text-darkPurple flex flex-col justify-center">
                  {{ item.data.orgDesignationLocations[0].location.name }}
                </p>
                <span v-if="item.data.orgDesignationLocations.length > 1" class="p-2 rounded-full text-blueCrayola"
                  style="background-color: rgba(33,118,255,0.24);">
                  +{{ item.data.orgDesignationLocations.length - 1 }}
                </span>
              </span>
            </span>
            <span class="text-carrotOrange" v-else-if="item.orgFunction">
              <p class="text-darkPurple">
                {{
                  item.data.orgFunction ? item.data.orgFunction.name : "------"
                }}
              </p>
              {{
                item.data.orgFunction
                  ? item.data.orgFunction.hierarchy
                    ? item.data.orgFunction.hierarchy.name
                    : "------"
                  : "------"
              }}
            </span>
            <span class="text-carrotOrange" v-else-if="item.payGrades">
              <p class="text-darkPurple">
                {{
                  item.data.payGrades.paygrades[0]
                    ? item.data.payGrades.paygrades[0].paygrade.payGradeId
                    : "-----"
                }}
              </p>
              {{
                item.data.payGrades.paygrades[0]
                  ? convertToCurrency(
                    item.data.payGrades.paygrades[0].paygrade.rangeMinimum
                  )
                  : convertToCurrency(0)
              }}
              -
              {{
                item.data.payGrades.paygrades[0]
                  ? convertToCurrency(
                    item.data.payGrades.paygrades[0].paygrade.rangeMaximum
                  )
                  : convertToCurrency(0)
              }}
            </span>

            <span v-else-if="item.id">
              <Menu left top="-150" margin="24" class="my-2 p-0">
                <template v-slot:title>
                  <icon icon-name="more_icon" size="xs" />
                </template>
                <div style="min-width: 180px; min-height: 81px" class="py-3 px-2">
                  <div class="flex py-1 px-3 more h-8 cursor-pointer" @click="handleEdit(item.data.id)">
                    <icon icon-name="edit" class-name="text-blueCrayola mr-2" size="xs" />
                    <p class="pt-1">Edit</p>
                  </div>
                  <div class="flex py-1 px-3 more h-8 cursor-pointer" @click="handlePayBand(item.data.id)">
                    <icon icon-name="icon-eye" class-name="text-darkPurple mr-2" size="xs" />
                    <p class="pt-1">View Payband</p>
                  </div>
                  <div class="flex px-3 py-1 more h-8 cursor-pointer" @click="confirmDelete(item.data.id)">
                    <icon icon-name="delete" class-name="text-desire mr-2" size="xsm" />
                    <p class="pt-1">Delete</p>
                  </div>
                </div>
              </Menu>
            </span>
          </template>
        </sTable>
      </div>
      <div v-else>
        <error-page />
      </div>
    </div>

    <RightSideBar v-if="openPayBandModal" close-button @close="(openPayBandModal = false)">
      <template v-slot:title>
        <p class="text-darkPurple">
          PayInfo
        </p>
      </template>
      <template>
        <h2 class="text-gray-800 font-semibold text-sm">
          Sales Representative - <span class="text-darkPurple font-bold">JOB LEVEL 2</span>
        </h2>
        <div class="p-6 w-full bg-white rounded-xl border mt-4 space-y-8">
          <div v-for="(item, index) in roles" :key="index" class="rounded-lg space-y-1">
            <div class="flex justify-between items-center">
              <p class="font-semibold text-sm text-gray-700">
                {{ item.title }} -
                <span class="text-carrotOrange font-bold uppercase">{{ item.grade }}</span>
              </p>
            </div>
            <div class="text-xs text-gray-500 flex items-center gap-1 mb-5">
              <Icon icon-name="icon-location" class="text-gray-500" size="xs" />
              <span>{{ item.location }}</span>
            </div>

            <div>
              <p class="text-xs font-bold mb-1 uppercase mt-5">Pay Info</p>
              <div class="flex flex-col gap-1 text-sm mt-1 bg-gray-100 px-2 py-2 rounded-lg w-fit">
                <div class="flex gap-1">
                  <Icon icon-name="refund-line" size="xs" />
                  <span class="text-black font-bold text-sm">Pay Range</span>
                </div>
                <span class="text-gray-700">{{ item.payRange }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </RightSideBar>


    <RightSideBar v-if="openModal" @submit="editMode ? updateDesignation() : createDesignation()"
      @close="(openModal = false), reset()" submit="Save" :loading="loading"
      :button-class="`bg-dynamicBackBtn text-white`" :disabled-button="disableBtn">
      <template v-slot:title>
        <p class="text-darkPurple">
          {{ editMode ? "Edit Designation" : "Add New Designation" }}
        </p>
      </template>
      <template v-slot:subtitle>
        <p class="font-semibold text-darkPurple">
          Which of these two best describe the Designation?
        </p>
        <radio-button :options="categoryArray" col-span="col-span-6" class="m-4 text-darkPurple" row-gap="gap-y-5"
          v-model="designationCredentials.isSupervisory" />
      </template>
      <div>
        <p class="text-darkPurple">Designation Details</p>
        <div class="grid grid-cols-12 gap-2 gap-y-4 text-darkPurple" style="margin-top: 1.125rem">
          <div class="col-span-12">
            <c-select placeholder="--Select--" :options="locationData" @input="formattedLocationTags($event)" label="Location"
              variant="w-full" v-model="designationCredentials.locationIds[0]" />
          </div>
          <div class="col-span-12">
            <c-select placeholder="--Select--" :options="functions" @input="populateCostCenter" label="Organisational Unit"
              variant="w-full" v-model="designationCredentials.functionId" />
          </div>
          <div class="col-span-12">
            <c-text placeholder="Automatically Loaded from Selected Function" disabled label="Cost Centre"
              variant="w-full" v-model="designationCredentials.costCentre" />
          </div>
          <div class="col-span-12">
            <c-text placeholder="--Enter Designation Name--" variant="w-full " label="Job Title"
              v-model="designationCredentials.name" />
          </div>
          <div class="col-span-12">
            <c-select placeholder="--Select--" :options="levelsArray" label="Job Level" variant="w-full"
              v-model="getLevel" />
          </div>
          <div class="col-span-12">
            <p class="text-darkPurple">Job Grade</p>
            <ComboBox :options="jobGrades" select @addSelectedTags="formattedJobTags($event)"
              @removeTag="removedJobTags($event)" no-custom />
          </div>
          <div class="col-span-12">
            <c-select placeholder="--Select--" :options="[
              { id: 'true', name: 'Yes' },
              { id: 'false', name: 'No' },
            ]" label="Eligible for Overtime?" variant="w-full" v-model="designationCredentials.enabledOvertime" />
          </div>
          <div class="col-span-12">
            <c-select placeholder="--Select--" :options="reportingLine" variant="w-full" label="Reporting line"
              v-model="designationCredentials.reportingTo" />
          </div>
          <div class="col-span-12">
            <checkbox label="Set up dotted line reporting for this designation." class="cursor-pointer"
              checkbox-size="height:16px; width:16px; margin-top:4px;" label-style="color:#333333"
              @change="handleDottedReporting" v-model="isDottedReportingTo"/>
          </div>
          <div class="col-span-12" v-if="isDotted">
            <c-select placeholder="--Select--" :options="supervisoryDesignation" variant="w-full"
              label="Dotted Reporting line" v-model="designationCredentials.dottedReportingTo" />
          </div>
          <div class="col-span-12" v-if="payBandSetup">
            <p class="mt-1 font-semibold">Pay Info</p>
            <div class="col-span-12 my-4">
              <c-text disabled label="Pay Grade" variant="w-full" v-model="bandName" />
            </div>
            <p class="text-sm">Pay Range</p>
            <div class="grid grid-cols-12 mt-1">
              <div class="col-span-5">
                <c-text disabled label="" variant="w-full" v-model="min" />
              </div>
              <div class="col-span-2 pt-3 text-center text-base text-romanSilver">--to--</div>
              <div class="col-span-5">
                <c-text disabled label="" variant="w-full" v-model="max" />
              </div>
            </div>
          </div>
          <p class="col-span-12 text-flame">
            {{ error }}
          </p>
        </div>
      </div>
    </RightSideBar>
    <Modal v-if="dialogDel">
      <Card class="p-5 flex flex-col max-w-md">
        <div class>
          <p class="font-bold ml-4 my-5 text-center">
            Are you sure you want to delete this Designation?
          </p>
          <div class="flex">
            <Button class="text-white" :background="appearance.buttonColor || defaultBTNColor"
              @click="deleteDesignation">
              Yes
            </Button>
            <Button background-color="none" class="text-dynamicBackBtn border border-solid border-dynamicBackBtn ml-4"
              @click="dialogDel = false">
              Cancel
            </Button>
          </div>
        </div>
      </Card>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import { clone } from "lodash";
import STable from "@scelloo/cloudenly-ui/src/components/table";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import ErrorPage from "@/modules/Admin/error403";
import CardFooter from "@/components/CardFooter";
import Card from "@/components/Card";
import Button from "@/components/Button";
import Menu from "@/components/Menu";
import RightSideBar from "@/components/RightSideBar";
import RadioButton from "@/components/RadioButton";
import Modal from "@/components/Modal";
import ComboBox from "@/components/ComboBox";
import Checkbox from "@/components/Checkbox";

export default {
  name: "Designation",
  components: {
    Button,
    Card,
    Checkbox,
    CardFooter,
    ComboBox,
    Breadcrumb,
    ErrorPage,
    CText,
    CSelect,
    Menu,
    STable,
    RightSideBar,
    Modal,
    RadioButton,
  },
  data() {
    return {
      isDottedReportingTo: false,
      disableBtn: false,
      designationArray: [],
      bandError: "",
      openModal: false,
      openPayBandModal: false,
      editMode: false,
      showError: false,
      dialogDel: false,
      designationId: "",
      isDotted: false,
      min: "",
      max: "",
      bandName: "",
      loadingData: true,
      loading: false,
      itemsPerPage: null,
      numberOfPage: null,
      searchWord: null,
      isActive: null,
      sortType: null,
      metaData: {},
      roles: [
        {
          title: "Sales and Marketing",
          grade: "Grade 1",
          location: "Abuja, Nigeria",
          payRange: "₦2,000,000.00 to ₦4,000,000.00"
        },
        {
          title: "Sales and Marketing",
          grade: "Grade 2",
          location: "Lagos, Nigeria",
          payRange: "₦2,400,000.00 to ₦4,400,000.00"
        },
        {
          title: "Sales and Marketing",
          grade: "Grade 3",
          location: "Enugu, Nigeria",
          payRange: "₦2,600,000.00 to ₦4,600,000.00"
        }
      ],
      functions: [],
      designations: [],
      reportingLine: [],
      hierarchy: [],
      levelsArray: [],
      getLevel: "",
      payBandSetup: false,
      payRange: null,
      payGrade: null,
      timeout: null,
      error: "",
      locationData: [],
      jobGrades: [],
      designationCredentials: {
        name: "",
        isSupervisory: true,
        functionId: null,
        reportingTo: null,
        dottedReportingTo: null,
        enabledOvertime: null,
        levelId: null,
        costCentre: null,
        locationIds: [],
        jobGradeIds: []
      },
      breadcrumbs: [
        {
          disabled: false,
          text: "Organisation",
          id: "",
        },
        {
          disabled: false,
          text: "Designations",
          id: "Designations",
        },
      ],
      categoryArray: [
        { name: "Supervisory", radioName: "designation", value: true },
        { name: "Non-Supervisory", radioName: "designation", value: false },
      ],
    };
  },
  watch: {
    getLevel(val) {
      this.designationCredentials.levelId = val;
      this.getLevelPayBand(val);
    },
  },
  methods: {
    formattedLocationTags(selectedOption) {
      if (selectedOption === 'All Locations') {
        this.designationCredentials.locationIds = this.locationData
          .filter(opt => opt.id !== 'All Locations')
          .map(opt => opt.id);
      }
      else {
        // Update your credentials
        this.designationCredentials.locationIds = [ selectedOption ]
      }

      // Update reporting line options based on selected locations
      this.getReportingLineOptions();
    },

    removedLocationTags(removedId) {
      // Update the option's checked state
      const option = this.locationData.find(opt => opt.id === removedId)
      if (option) option.checked = false
      // Update your credentials
      this.designationCredentials.locationIds =
        this.designationCredentials.locationIds.filter(item => item !== removedId)
        if (this.designationCredentials.locationIds.length !== 0) {
          this.reportingLine = []
          return;
        }
        // Update reporting line options based on remaining locations
      getReportingLineOptions();
    },

    formattedJobTags(selectedOption) {
      // Update the option's checked state
      const option = this.jobGrades.find(opt => opt.id === selectedOption.id)
      if (option) option.checked = true
      // Update your credentials
      this.designationCredentials.jobGradeIds = this.jobGrades
        .filter(opt => opt.checked)
        .map(opt => opt.id)
    },

    removedJobTags(removedId) {
      // Update the option's checked state
      const option = this.jobGrades.find(opt => opt.id === removedId)
      if (option) option.checked = false
      // Update your credentials
      this.designationCredentials.jobGradesIds =
        this.designationCredentials.jobGradeIds.filter(item => item !== removedId)
    },


    getLevelPayBand(level) {
      this.$_getLevelPayBand(level).then((result) => {
        this.payBandSetup = result.data.isSetup;
        if (!this.payBandSetup) {
          this.bandError = "No PayBand for this Job Level";
        } else {
          this.max = this.convertToCurrency(result.data.payband.upperBand);
          this.min = this.convertToCurrency(result.data.payband.lowerBand);
          this.bandName = result.data.payband.name;
        }
      });
    },
    handlePayBand(id) {
      this.openPayBandModal = true;
    },
    reset() {
      this.designationCredentials = {
        name: "",
        isSupervisory: true,
        functionId: null,
        reportingTo: null,
        dottedReportingTo: null,
        levelId: null,
        costCentre: null,
        jobGradeIds: [],
        locationIds: [],
      };
      this.min = "";
      this.editMode = false;
      this.isDotted = false;
      this.max = "";
      this.getLevel = "";
      this.payBandSetup = false;
      this.getLocations();
      this.getJobGrades();
    },
    checkBound(firstValue, secondValue) {
      if (
        firstValue !== null ||
        firstValue !== 0 ||
        secondValue !== null ||
        secondValue !== 0
      ) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.error = "";
          let valueOne = this.handleSplit(firstValue);
          let valueTwo =
            typeof secondValue === "string"
              ? this.handleSplit(secondValue)
              : secondValue;
          valueOne = Number(valueOne);
          valueTwo = Number(valueTwo);
          if (valueOne > valueTwo) {
            this.error = "Minimum value can't be higher than Maximum value";
          }
        }, 1000);
      }
    },
    async confirmDelete(id) {
      try {
        await this.$handlePrivilege("designation", "deleteDesignation");
        this.designationId = id;
        this.dialogDel = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        })
      }
    },
    async deleteDesignation() {
      try {
        this.dialogDel = false;
        this.loadingData = true;
        await this.$_deleteDesignation([this.designationId]);
        this.$toasted.success("Designation deleted successfully", {
          duration: 3000,
        });
        await this.getDesignation("");
      }
      catch (e) {
        this.$toasted.error(e.response?.data?.message, { duration: 10000 })
        this.loadingData = false
      }
    },
    async handleClick() {
      try {
        await this.$handlePrivilege("designation", "addNewDesignation");
        this.openModal = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    handleSplit(value) {
      return value.split(",").join("");
    },
    async updateDesignation() {
      this.disableBtn = true;
      if (!this.error) {
        this.designationCredentials.lowerAnnualSalaryBand = Number(
          this.handleSplit(this.min)
        );
        this.designationCredentials.upperAnnualSalaryBand = Number(
          this.handleSplit(this.max)
        );
        if (this.designationCredentials.reportingTo === "null") {
          this.designationCredentials.reportingTo = null;
        }
        if (this.designationCredentials.dottedReportingTo === "null") {
          this.designationCredentials.dottedReportingTo = null;
        }
        this.designationCredentials.id = this.designationId;
        try {
          await this.$_updateDesignation(this.designationCredentials);
          this.openModal = false;
          this.$router.push({
            name: "designation",
          });
          this.$toasted.success("Designation updated successfully", {
            duration: 3000,
          });
          this.getDesignation("");
          this.reset();
          this.disableBtn = false;
        } catch (error) {
          this.$toasted.error("Designation not updated successfully", {
            duration: 3000,
          });
          this.disableBtn = false;
          throw new Error(error);
        }
      }
    },
    async handleEdit(id) {
      this.jobGrades = this.jobGrades.map((item) => {
        item.checked = false;
        return item;
      });
      this.locationData = this.locationData.map((item) => {
        item.checked = false;
        return item;
      });
      try {
        await this.$handlePrivilege("designation", "editDesignation");
        this.loading = true;
        this.openModal = true;
        this.editMode = true;
        this.$_getOneDesignations(id).then((result) => {
          this.designationCredentials = result.data.designation;
          if (this.designationCredentials.lowerAnnualSalaryBand) {
            this.min = this.convertToCurrency(
              this.designationCredentials.lowerAnnualSalaryBand
            );
          }
          if (this.designationCredentials.upperAnnualSalaryBand) {
            this.max = this.convertToCurrency(
              this.designationCredentials.upperAnnualSalaryBand
            );
          }
          if(this.designationCredentials.dottedReportingTo){
            this.isDottedReportingTo = true;
            this.handleDottedReporting();
          }
          this.designationCredentials.locationIds = result.data.designation.orgDesignationLocations.map(
            (item) => item.location.id
          );
          this.designationCredentials.jobGradeIds = result.data.designation.orgDesignationJobGrades.map(
            (item) => item.orgJobGrade.id
          );
          if (this.designationCredentials.locationIds.length !== 0) {
            // Update reporting line options based on loaded locations
            this.getReportingLineOptions();
          }

          this.jobGrades = this.jobGrades.map((item) => {
            if (this.designationCredentials.jobGradeIds.includes(item.id)) {
              item.checked = true;
            }
            return item;
          });

          this.locationData = this.locationData.map((item) => {
            if (this.designationCredentials.locationIds.includes(item.id)) {
              item.checked = true;
            }
            return item;
          });
          this.getLevel = result.data.designation.levelId;
          this.designationId = id;
          this.loading = false;
        });
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    async createDesignation() {
      this.disableBtn = true;
      if (!this.error) {
        this.designationCredentials.lowerAnnualSalaryBand = Number(
          this.handleSplit(this.min)
        );
        this.designationCredentials.upperAnnualSalaryBand = Number(
          this.handleSplit(this.max)
        );
        if (this.designationCredentials.reportingTo === "null") {
          this.designationCredentials.reportingTo = null;
        }
        if (this.designationCredentials.dottedReportingTo === "null") {
          this.designationCredentials.dottedReportingTo = null;
        }
        this.designationCredentials.orgId = this.$AuthUser.orgId;
        this.designationCredentials.createdBy = this.$AuthUser.id;
        try {
          await this.$_createDesignation(this.designationCredentials);
          this.loadingData = true;
          this.reset();
          this.$toasted.success("Designation created successfully", {
            duration: 3000,
          });
          this.getDesignation("");
          this.openModal = false;
          this.disableBtn = false;
        } catch (error) {
          const errorMessage = error.response?.data?.message ||
            (error.response?.data?.errors && (
              Array.isArray(error.response.data.errors) ? error.response.data.errors[0] :
              Object.values(error.response.data.errors)[0]?.[0] || Object.values(error.response.data.errors)[0]
            )) ||
            "An error occurred while creating the designation";

          this.$toasted.error(errorMessage, {
            duration: 3000,
          });
          this.disableBtn = false;
          this.reset();
        }
      }
    },
    queryUpdate() {
      const search = this.searchWord ? `&search=${this.searchWord}` : "";
      const sort = this.sortType ? `&sort=${this.sortType}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getDesignation(`${sort}${search}${pageNumber}${itemPage}`);
    },
    async print() {
      await this.$htmlToPaper("printMe");
    },
    handleSearch(searchWord) {
      this.loadingData = true;
      if (searchWord) {
        this.searchWord = searchWord;
        this.queryUpdate();
      } else {
        this.searchWord = null;
        this.queryUpdate();
      }
    },
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },
    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },
    handleSort(sortType) {
      this.loadingData = true;
      const changeSortType = sortType.split(":");
      let result;
      if (changeSortType[0] === "createdAt") {
        result = sortType;
      } else {
        result = `name:${changeSortType[1]}`;
      }
      this.sortType = result;
      this.queryUpdate();
    },
    reload() {
      this.loadingData = true;
      this.getDesignation("");
    },
    async getFunctions() {
      try {
        const response = await this.$_getFunction(this.$orgId);
        this.functions = response.data.functions;
      } catch (error) {
        throw new Error(error);
      }
    },
    handleDottedReporting() {
      this.isDotted = !this.isDotted;
    },
    getLocations(query) {
      this.$_getHumanarLocations(query).then((result) => {
        this.locationData = result.data.outlets.map(item => ({
          name: item.name,
          id: item.id,
          checked: false
        }));
        this.locationData.unshift({
          name: 'All Locations',
          id: 'All Locations',
          checked: false,
          disabled: false
        })
        this.metaData = result.data.meta;
        this.loading = false;
      });
    },
    async getLevels() {
      try {
        const response = await this.$_getLevels("");
        this.levelsArray = response.data.levels;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getDesignation(payload) {
      try {
        const response = await this.$_getDesignationsWithPayband(payload);
        this.designationArray = clone(response.data.designations);
        this.designations = response.data.designations;
        this.metaData = response.data.meta;
        this.loadingData = false;
        this.designations.push({ name: "Nil", id: "null" });
      } catch (error) {
        throw new Error(error);
      }
    },
    populateCostCenter(value) {
      const result = this.functions.find((element) => element.id === value);
      this.designationCredentials.costCentre = result.costCenter;
    },
    getJobGrades() {
      this.$_getJobGrade().then((response) => {
        this.jobGrades = response.data.grades.map((item) => ({
          name: item.name,
          id: item.id,
          checked: false
        }));
        this.loadingData = false;
      });
    },
    getAllDesignations() {
      const { functionId } = this.designationCredentials;
      let queryParams = 'source=designations';

      if (functionId) {
        queryParams += `&functionId=${functionId}`;
      }

      this.$_getDesignations(queryParams).then((response) => {
        this.reportingLine = response.data.designations
          .filter(designation => designation.isSupervisory)
          .map(({ id, name }) => ({ id, name }));
      });
    },

    // Separate method for reporting line options based on selected locations
    getReportingLineOptions() {
      const { locationIds, functionId } = this.designationCredentials;

      // if (locationIds.length === 0) {
      //   // If no locations selected, get all supervisory designations
      //   this.getAllDesignations();
      //   return;
      // }

      let queryParams = `locationIds=${locationIds.join(',')}&source=designations`;

      if (functionId) {
        queryParams += `&functionId=${functionId}`;
      }

      this.$_getDesignations(queryParams).then((response) => {
        this.reportingLine = response.data.designations
          .filter(designation => designation.isSupervisory)
          .map(({ id, name }) => ({ id, name }));
      });
    },
  },
  computed: {
    filteredFunctions() {
      return this.$store.state.org.getAllFunctions;
    },
    supervisoryDesignation() {
      const hasSupervisory = this.designations.filter(item => item.isSupervisory);
      return hasSupervisory.filter(item => item.id !== this.designationCredentials.reportingTo)
    },
    designationHeader() {
      return [
        { title: "DESIGNATION", value: "name", width: "20" },
        { title: "TYPE", value: "isSupervisory", width: "15" },
        { title: "LOCATION", value: "orgDesignationLocations", width: "15" },
        { title: "JOB LEVEL ID", value: "level", width: "15" },
        { title: "ORGANISATIONAL UNIT", value: "orgFunction", width: "15" },
        { title: "REPORTING LINE", value: "reportsTo", width: "15" },
        { title: "Pay Info", value: "payGrades", width: "30" },
        { title: "", value: "id", image: true },
      ];
    },
    ...mapState({
      defaultBTNColor: (state) => state.orgAppearance.defaultBtnColor,
      appearance: (state) => state.orgAppearance.orgAppearanceData,
    }),
  },
  async mounted() {
    try {
      await this.$handlePrivilege("designation", "viewRegister");
      this.showError = false
      this.getFunctions();
      this.getLevels();
      this.getDesignation("");
      this.getLocations();
      this.getJobGrades();
    } catch (error) {
      this.showError = true
      this.loadingData = false;
    }
  },
};
</script>

<style scoped>
.custom-radius {
  border-radius: 7px;
}
</style>

<style>
.bg-fadeFlame {
  background-color: rgba(241, 90, 41, 0.5);
}
</style>